export default "__VITE_ASSET__BiPtO7WS__"